export const getDataForDropdown = (parts = []) => {
  return parts.map((part) => ({
    'text': `${part.code} - ${part.name}`,
    'key': part.code,
    'value': part.code,
  }));
};

function labelBlueprint(itemSelect) {
  const limitString = 40;
  const itemName = itemSelect.name;
  const partName =
    itemName.length > limitString ? itemName.slice(0, limitString) : itemName;
  return `^XA
  ^FX part codigo
  ^FO140,35 ^GB90,24,24,B^FS 
  ^FO145,40^FR^A0,20^FDCODIGO:^FS
  ^CFA,35
  ^FO260, 35^ADN^FR^FD${itemSelect.code}^FS
  ^FX franchise
  ^CFA,25
  ^FO140,75 ^GB90,24,24,B^FS 
  ^FO145,80^FR^A0,20^FDDESCRIP: ^FS
  ^FX part name
  ^CFA,26
  ^FO260,80^A0,25^FD${partName}^FS
  ^FX bar code
  ^FO145,120 ^BY1 ^B3N,N,75,Y,N ^FD${itemSelect.code}^FS 
  ^FX part ubicacion
  ^FO395,130^A0,20^FDUBICACION^FS
  ^CFA,45
  ^FO395,155^ADN^FD${itemSelect.location}^FS
  ^XZ`;
}

export const generateLabelsString = (quantity, itemSelect) => {
  let labelStr = '';
  for (let i = 0; i < quantity; i++) {
    labelStr += `${labelBlueprint(itemSelect)}\n`;
  }
  return labelStr;
};

export const printLabels = (labelsStrt) => {
  const element = document.createElement('iframe');
  const file = new Blob([labelsStrt], {
    'type': 'text/plain',
  });
  const url = URL.createObjectURL(file);
  element.src = url;
  element.style.display = 'none';
  element.style.fontFamily = 'none';

  const printWindow = window.open(element.src, '_blank');
  printWindow.print();
  printWindow.onfocus = function() {
    setTimeout(function() {
      printWindow.close();
      URL.revokeObjectURL(url);
    }, 300);
  };
};
